const { getElement } = window.BAO.Utils

class ProductAccordions extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleOptionsTrigger = this.handleOptionsTrigger.bind(this)
    this.onSizeGuideClose = this.onSizeGuideClose.bind(this)
    this.onProductContentToggle = this.onProductContentToggle.bind(this)

    this.handlePreorderTrigger = this.handlePreorderTrigger.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)

    this.externalEls['options-trigger']?.elements.forEach(
      (optionsTriggerEl) => {
        this.listeners.add(
          optionsTriggerEl,
          'click',
          this.handleOptionsTrigger,
        )
      },
    )

    this.listeners.add(document, 'click', this.handlePreorderTrigger)

    this.listeners.add(document, 'drawerClosed', this.onSizeGuideClose)
    this.listeners.add(
      document,
      'productContentToggle',
      this.onProductContentToggle,
    )
  }

  onProductContentToggle (event) {
    if (event.detail.toggle === true) {
      this.els.item.elements.forEach((itemEl) => {
        const isDescription = itemEl.dataset.type === 'description'

        itemEl.setAttribute('aria-expanded', isDescription ? 'true' : 'false')

        const bodyEl = getElement(this.els.body.selector, {
          context: itemEl,
        })
        const interactiveElements = bodyEl.querySelectorAll(
          'button, a, input, select, textarea',
        )

        bodyEl.setAttribute('aria-hidden', isDescription ? 'false' : 'true')

        interactiveElements.forEach((el) => {
          el.setAttribute('tabindex', isDescription ? '0' : '-1')
        })
      })
    } else {
      this.els.item.elements.forEach((itemEl) => {
        itemEl.setAttribute('aria-expanded', 'false')

        const bodyEl = getElement(this.els.body.selector, {
          context: itemEl,
        })
        const interactiveElements = bodyEl.querySelectorAll(
          'button, a, input, select, textarea',
        )

        bodyEl.setAttribute('aria-hidden', 'true')
        interactiveElements.forEach((el) => {
          el.setAttribute('tabindex', '-1')
        })
      })

      this.externalEls.main.element.classList.remove(
        'prd-Detail_Content-active',
      )
      this.externalEls.main.element.removeAttribute('data-active')
    }
  }

  onSizeGuideClose (event) {
    if (event.detail.key !== 'size-guide') return

    this.els.item.elements.forEach((itemEl) => {
      itemEl.setAttribute('aria-expanded', 'false')

      const bodyEl = getElement(this.els.body.selector, {
        context: itemEl,
      })
      const interactiveElements = bodyEl.querySelectorAll(
        'button, a, input, select, textarea',
      )

      bodyEl.setAttribute('aria-hidden', 'true')
      interactiveElements.forEach((el) => {
        el.setAttribute('tabindex', '-1')
      })
    })

    this.externalEls.main.element.classList.remove('prd-Detail_Content-active')
    this.externalEls.main.element.removeAttribute('data-active')
  }

  handleTrigger (event) {
    if (!event.target.closest(this.els?.trigger?.selector)) return

    const itemEl = event.target.closest(this.els?.trigger?.selector)

    this.toggleItems(itemEl.dataset.type)
  }

  handleOptionsTrigger () {
    const optionsItem = this.els.item.elements.find(
      (itemEl) => itemEl.dataset.type === 'options',
    )

    if (optionsItem && optionsItem.getAttribute('aria-expanded') !== 'true') {
      this.toggleItems('options')
    }
  }

  handlePreorderTrigger (event) {
    if (
      !event.target.closest(
        '[data-product-accordions-external-el="preorder-trigger"]',
      )
    ) {
      return
    }

    window.setTimeout(() => {
      this.toggleItems('preorder')
    }, 500)
  }

  toggleItems (accordionType) {
    let optionsCurrentStatus = false

    this.els.item.elements.forEach((itemEl) => {
      const isCurrentAccordion = itemEl.dataset.type === accordionType
      const bodyEl = getElement(this.els.body.selector, {
        context: itemEl,
      })
      const interactiveElements = bodyEl.querySelectorAll(
        'button, a, input, select, textarea',
      )

      if (isCurrentAccordion) {
        const isExpanded = itemEl.getAttribute('aria-expanded') === 'true'
        const newExpandedState = !isExpanded

        itemEl.setAttribute('aria-expanded', newExpandedState)

        bodyEl.setAttribute('aria-hidden', !newExpandedState)

        interactiveElements.forEach((el) => {
          el.setAttribute('tabindex', newExpandedState ? '0' : '-1')
        })

        optionsCurrentStatus = newExpandedState
      } else if (this.dataset.type === 'oneopen') {
        itemEl.setAttribute('aria-expanded', 'false')

        if (bodyEl) {
          bodyEl.setAttribute('aria-hidden', 'true')

          interactiveElements.forEach((el) => {
            el.setAttribute('tabindex', '-1')
          })
        }
      }
    })

    this.externalEls.main.element.classList.toggle(
      'prd-Detail_Content-active',
      optionsCurrentStatus,
    )
    this.externalEls.main.element.setAttribute('data-active', accordionType)

    if (!this.externalEls['options-text']?.exists) return

    this.externalEls['options-text'].elements.forEach((optionsTextEl) => {
      optionsTextEl.setAttribute(
        'aria-hidden',
        accordionType === 'options' && optionsCurrentStatus
          ? optionsTextEl.dataset.text === 'atc'
          : optionsTextEl.dataset.text === 'sas',
      )
    })
  }
}

if (!customElements.get('product-accordions')) {
  customElements.define('product-accordions', ProductAccordions)
}
